import React from "react";
import { MessageSquareQuote, FileSearch, Handshake, KeyRound } from "lucide-react";

const STEPS = [
    {
        icon: MessageSquareQuote,
        title: "Discovery",
        desc: "A no-obligation conversation to understand your goals, circumstances and concerns.",
    },
    {
        icon: FileSearch,
        title: "Assessment",
        desc: "We carefully assess your options, costs and risks before making any recommendation.",
    },
    {
        icon: Handshake,
        title: "Recommendation",
        desc: "Personalised, transparent and fully compliant guidance tailored to your situation.",
    },
    {
        icon: KeyRound,
        title: "Ongoing support",
        desc: "A lasting relationship — support through application, completion and future reviews.",
    },
];

export default function Process() {
    return (
        <section
            data-testid="process-section"
            className="relative py-14 md:py-20 bg-brand-primary text-brand-bg overflow-hidden"
        >
            <div className="absolute inset-0 grain opacity-20" aria-hidden="true" />
            <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-white/70" />
                            <span className="text-xs uppercase tracking-[0.24em] text-white font-semibold">
                                Our Approach
                            </span>
                        </div>
                        <h2 className="font-serif-editorial text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-white">
                            Considered, transparent,
                            <br />
                            <em className="italic font-light text-[#A7C6FF]">
                                any time you need us.
                            </em>
                        </h2>
                    </div>
                    <div className="md:col-span-6 md:col-start-7 flex items-end">
                        <p className="text-lg text-white/80 leading-relaxed">
                            Every client's situation is unique. We take the time to
                            understand your circumstances, goals and concerns before
                            offering any recommendations — so guidance is personalised,
                            transparent and fully compliant.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6">
                    {STEPS.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <div
                                key={s.title}
                                data-testid={`process-step-${i + 1}`}
                                className="relative pt-10"
                            >
                                <div className="absolute top-0 left-0 text-xs tracking-[0.28em] text-[#A7C6FF] font-semibold">
                                    STEP · 0{i + 1}
                                </div>
                                <div className="h-14 w-14 border border-white/35 flex items-center justify-center text-white mb-6">
                                    <Icon size={22} />
                                </div>
                                <h3 className="font-serif-editorial text-3xl mb-3 text-white">
                                    {s.title}
                                </h3>
                                <p className="text-white/80 leading-relaxed">{s.desc}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
